import React from 'react'
import CreateCourier from '../components/CreateCourier/CreateCourier'

const CreateCourierPage = () => {
    return <CreateCourier />
}

export default CreateCourierPage
